import axios from 'axios'

export default {
  install(Vue: any, options: any) {
    Vue.$postCode = Vue.prototype.$postCode = {
      url: 'https://api.postcodes.io',

      async createRequestObject(method: string = 'GET', url: string = '', data: any) {
        const settings = { mode: 'cors', method: '', url: '' }
        settings.method = method
        settings.url = url

        const instance = axios.create()
        delete instance.defaults.headers.common.Authorization

        try {
          // @ts-ignore
          return await instance(settings).then(resp => {
            return resp.data
          })
        } catch (error) {}
      },

      getDefaultUrl(command: string) {
        let url = this.url
        url += '/postcodes' + command
        return url
      },

      detailsByPostCode(postcode: string) {
        let url = this.getDefaultUrl('/')
        url += postcode
        return this.createRequestObject('GET', url)
      },

      detailsByCoordinates(coord: { lat: Number; lng: Number }) {
        if (!(coord.lng || coord.lat)) {
          throw new Error('Invalid coordinates')
        }
        let url = this.getDefaultUrl('?')
        url += 'lon=' + coord.lng
        url += '&'
        url += 'lat=' + coord.lat
        return this.createRequestObject('GET', url)
      },
    }
  },
}
